export const getJiraHeritageDependencies = () => [
	// superbatch resources

	// analytics
	'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client',

	// dependencies from HeaderFooterRendering
	'wrc!jira.webresources:key-commands',
	'wrc!jira.webresources:header',

	// . dialog
	'wrc!com.atlassian.administration.atlassian-admin-quicksearch-jira:admin-quicksearch-webresources',

	// overrides for AUI, styles and bridge apis
	'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-general',
	'wrc!com.atlassian.jira.jira-atlaskit-plugin:overrides-dialogs',

	'wrc!jira.webresources:global-static',

	// browser metrics
	'wrc!com.atlassian.jira.plugins.jira-browser-metrics:contrib',
	'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:impl',
	'wrc!com.atlassian.plugins.browser.metrics.browser-metrics-plugin:api',

	// repository shortcuts from navigation
	'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:repository-shortcuts-navigation-next',

	// issue view resources
	'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources-init',

	// create board dialog
	'wrc!com.pyxis.greenhopper.jira:gh-create-board-adg3-no-condition',

	// old analytics library
	'wrc!com.atlassian.analytics.analytics-client:js-events',

	// frontend cache
	'wrc!com.atlassian.jira.jira-atlaskit-plugin:global-cache',

	// impersonation flag (logged as someone)
	'wrc!com.atlassian.crowd.user-provisioning-vertigo-plugin:impersonation-resources',

	// flag displayed when there are too many emails on the instance
	'wrc!jira.webresources:spam-protection-flags',

	// in-product announcements (displayed e.g. if there is an incident)
	'wrc!com.atlassian.pas:pas-everypage-static',

	// Bento resources
	'wrc!com.atlassian.jira.jira-fileviewer-plugin:fileviewer',
	'wrc!com.atlassian.auiplugin:dialog2',
	'wrc!com.atlassian.jira.jira-fileviewer-plugin:atlassian-fileviewer',
	'wrc!com.atlassian.jira.jira-issue-nav-plugin:stylesheets',
];
